import { useState } from 'react';

import { NavigationHistoryRoutes } from '../types';

export const useNavigationHistoryRoutes = () => {
  const [ navigationHistoryRoutes, setNavigationHistoryRoutes ] = useState<NavigationHistoryRoutes>();

  return { navigationHistoryRoutes, setNavigationHistoryRoutes };
};
